import React from "react";
const CaseStudies = () => <section>hey i'm CaseStudies</section>;
export default CaseStudies;
